import { render, staticRenderFns } from "./NewNotificationsList.vue?vue&type=template&id=2e742b51&"
import script from "./NewNotificationsList.vue?vue&type=script&lang=js&"
export * from "./NewNotificationsList.vue?vue&type=script&lang=js&"
import style0 from "./ListGroup.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports